import {Path} from 'components/customer/BTM/entity/Path';
import {getSideSpec} from 'components/customer/BTM/entity/Side';
import {getCornerName} from 'components/customer/BTM/helper/getCornerName';

export const getSideName = (paths: Path[]) => (path: Path) => {
    if (path.side == null) {
        return getCornerName(path.index, paths);
    }

    return getSideSpec(path.side).key;
};
